export default __webpack_public_path__ + "static/media/login_side_image.98ca931c.jpg";